// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as TbPage10 from "../team-planner10/TbPage10.bs.js";
import * as TbPage14 from "../team-planner14/TbPage14.bs.js";
import * as TbPage15 from "../team-planner15/TbPage15.bs.js";
import * as TbPage16 from "../team-planner16/TbPage16.bs.js";
import * as TbPage17 from "../team-planner17/TbPage17.bs.js";
import * as TbPage18 from "../team-planner18/TbPage18.bs.js";
import * as TbPage46 from "../team-planner46/TbPage46.bs.js";
import * as TbPage76 from "../team-planner76/TbPage76.bs.js";
import * as TbUtils10 from "../team-planner10/TbUtils10.bs.js";
import * as TbUtils13 from "../team-planner13/TbUtils13.bs.js";
import * as TbUtils14 from "../team-planner14/TbUtils14.bs.js";
import * as TbUtils15 from "../team-planner15/TbUtils15.bs.js";
import * as TbUtils16 from "../team-planner16/TbUtils16.bs.js";
import * as TbUtils17 from "../team-planner17/TbUtils17.bs.js";
import * as TbUtils46 from "../team-planner46/TbUtils46.bs.js";
import * as TbUtils76 from "../team-planner76/TbUtils76.bs.js";
import * as ReactDnd from "react-dnd";
import * as ReactDndTouchBackend from "react-dnd-touch-backend";

function TeamPlannerPage(Props) {
  var initialBoardOpt = Props.initialBoard;
  var locale = Props.locale;
  var initialBoard = initialBoardOpt !== undefined ? initialBoardOpt : "";
  TbAtoms.useInit(undefined);
  var match = React.useState(function () {
        if (initialBoard.startsWith(TbUtils76.version)) {
          return /* Set76 */13;
        } else if (initialBoard.startsWith(TbUtils10.version)) {
          return /* Set10 */2;
        } else if (initialBoard.startsWith(TbUtils46.version)) {
          return /* Set46 */14;
        } else if (initialBoard.startsWith(TbUtils13.version)) {
          return /* Set13 */5;
        } else if (initialBoard.startsWith(TbUtils14.version)) {
          return /* Set14 */6;
        } else if (initialBoard.startsWith(TbUtils15.version)) {
          return /* Set15 */7;
        } else if (initialBoard.startsWith(TbUtils16.version)) {
          return /* Set16 */8;
        } else if (initialBoard.startsWith(TbUtils17.version)) {
          return /* Set17 */9;
        } else {
          return /* Set18 */10;
        }
      });
  var setSet = match[1];
  Router.use(undefined);
  var onGoToSet10 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set10 */2;
                      }));
        }), []);
  React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set13 */5;
                      }));
        }), []);
  var onGoToSet14 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set14 */6;
                      }));
        }), []);
  var onGoToSet15 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set15 */7;
                      }));
        }), []);
  var onGoToSet16 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set16 */8;
                      }));
        }), []);
  var onGoToSet17 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set17 */9;
                      }));
        }), []);
  var onGoToSet18 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set18 */10;
                      }));
        }), []);
  React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set46 */14;
                      }));
        }), []);
  React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set76 */13;
                      }));
        }), []);
  var tmp;
  switch (match[0]) {
    case /* Set10 */2 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set10 */2, React.createElement(TbPage10.make, {
                      onGoToSet6: onGoToSet14,
                      locale: locale,
                      board: initialBoard
                    }), undefined));
        break;
    case /* Set14 */6 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set14 */6, React.createElement(TbPage14.make, {
                      onGoToSet6: onGoToSet10,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set15 */7 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set15 */7, React.createElement(TbPage15.make, {
                      onGoToSet6: onGoToSet17,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set16 */8 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set16 */8, React.createElement(TbPage16.make, {
                      onGoToSet6: onGoToSet17,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set17 */9 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set17 */9, React.createElement(TbPage17.make, {
                      onGoToSet6: onGoToSet18,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set18 */10 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set18 */10, React.createElement(TbPage18.make, {
                      onGoToSet6: onGoToSet17,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set76 */13 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set76 */13, React.createElement(TbPage76.make, {
                      onGoToSet6: onGoToSet15,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set46 */14 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set46 */14, React.createElement(TbPage46.make, {
                      onGoToSet6: onGoToSet16,
                      locale: locale,
                      board: initialBoard,
                      exalteds: []
                    }), undefined));
        break;
    case /* Set9 */0 :
    case /* Set95 */1 :
    case /* Set11 */3 :
    case /* Set12 */4 :
    case /* Set13 */5 :
    case /* Set36 */11 :
    case /* Set56 */12 :
    case /* Set101 */15 :
    case /* Set151 */16 :
        tmp = null;
        break;
    
  }
  return React.createElement(ReactDnd.DndProvider, {
              backend: ReactDndTouchBackend.TouchBackend,
              options: {
                enableMouseEvents: true,
                enableKeyboardEvents: true,
                enableHoverOutsideTarget: true
              },
              children: React.createElement(AdLayout.make, {
                    children: tmp
                  })
            });
}

var make = TeamPlannerPage;

export {
  make ,
  
}
/* react Not a pure module */
